module.exports = __webpack_public_path__ + "static/media/call_now.c4148314.svg";